import type { ViewjobQuery } from "../__generated__/viewjob.gqlgenerated";

type AdditionalLinks = NonNullable<
  NonNullable<NonNullable<ViewjobQuery["viewjob"]>["details"]>["additionalLinks"]
>;
type AdditionalLink = AdditionalLinks["companySalaryLinks"][number];

const toElementModel = (link: AdditionalLink): viewjob.model.AdditionalLinksElementModel => ({
  surfaceElementLabel: link.surfaceElementLabel,
  surfaceElementUrl: link.surfaceElementUrl,
});

/**
 * Maps `ViewJobDetails.additionalLinks` onto the SEO additional-links view model.
 *
 * Presence is meaningful, not just contents: `ViewJobMainContent` uses the
 * model's presence to choose the AdditionalLinks surface over RelatedLinks, so a
 * payload whose sections are all empty maps to a present model with empty
 * sections rather than `undefined`. This matches the legacy REST path, which
 * carries an all-empty model through untouched. `AdditionalLinks` renders
 * nothing in that case via its own empty-section guard.
 *
 * Returns `undefined` only when the graph has no `additionalLinks` at all.
 */
export const buildAdditionalLinksViewModel = (
  viewjob: NonNullable<ViewjobQuery["viewjob"]>,
): component.additionallinks.AdditionalLinksViewModel | undefined => {
  const additionalLinks = viewjob.details?.additionalLinks;

  if (!additionalLinks) {
    return undefined;
  }

  return {
    careerGuideArticleLinks: additionalLinks.careerGuideArticleLinks.map(toElementModel),
    companySalaryLinks: additionalLinks.companySalaryLinks.map(toElementModel),
    nearbyLocationLinks: additionalLinks.nearbyLocationLinks.map(toElementModel),
    similarCategoryLinks: additionalLinks.similarCategoryLinks.map(toElementModel),
    similarJobTitleLinks: additionalLinks.similarJobTitleLinks.map(toElementModel),
  };
};
